// extracted by mini-css-extract-plugin
export default {"page":"NotFound_page__qJ5ch"};